// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d464547c","845":"15d85e07"}[chunkId] + ".chunk.js";
};